import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { Flame } from "lucide-react";

export default function HotspotTrend({ data = [] }) {
  return (
    <section className="trend-panel hs-trend" data-testid="hotspot-trend-panel">
      <div className="panel-heading">
        <div>
          <span className="section-kicker">TREN 7 HARI</span>
          <h3>Titik api harian · pola karhutla</h3>
        </div>
        <div className="chart-key">
          <span>
            <i className="sipongi-box" /> SiPongi
          </span>
          <span>
            <i className="firms-box" /> NASA FIRMS
          </span>
        </div>
      </div>
      <div className="chart" data-testid="hotspot-trend-chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} barCategoryGap="28%">
            <XAxis
              dataKey="label"
              tick={{ fill: "#718178", fontSize: 10 }}
              interval={0}
            />
            <YAxis
              tick={{ fill: "#718178", fontSize: 10 }}
              width={32}
              allowDecimals={false}
            />
            <Tooltip
              cursor={{ fill: "rgba(56,189,248,0.06)" }}
              contentStyle={{
                background: "#0f2440",
                border: "1px solid #2a5488",
                color: "#f1f5f9",
                fontSize: 12,
              }}
              formatter={(value, name) => [
                `${value} titik`,
                name === "sipongi" ? "SiPongi" : "NASA FIRMS",
              ]}
            />
            <Bar dataKey="sipongi" stackId="hs" fill="#f97316" />
            <Bar
              dataKey="firms"
              stackId="hs"
              fill="#ef4444"
              radius={[3, 3, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="hs-trend-foot">
        <Flame size={13} />
        <span>
          Total 7 hari:{" "}
          <b data-testid="hotspot-trend-total">
            {data.reduce((s, d) => s + (d.total || 0), 0)}
          </b>{" "}
          titik
        </span>
      </div>
    </section>
  );
}
